module.exports = __webpack_public_path__ + "img/plus-logo.7e909f33.webp";